export const OPTHINES = {
  voteName: '2019poject/2019shangyou_answer',
  themeColor: {
    activeBgColor: 'rgb(241, 110, 66)',
    inactiveBgColor: 'rgb(251, 220, 14)',
  },
  tabs: [
    {
      tabName: '排行榜',
      tabPath: '/2019ShangyouAnswerRanking/RankingList',
    },
    {
      tabName: '答人入驻',
      tabPath: '/2019ShangyouAnswerRanking/Register',
    },
    {
      tabName: '活动规则',
      tabPath: '/2019ShangyouAnswerRanking/Rules',
    },
  ],
};
